export default __webpack_public_path__ + "static/media/audio-attach.58bf8372.svg";